import makeRoutes from "@/routes/Base/Route";

export default makeRoutes('corecompanies').map(route => {
    return {
        ...route,
        meta: {perfil: 'root'}
    }
})